import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/Images/icono-realtor.png'


const _hoisted_1 = { class: "text-left no-printable" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "tw-flex tw-h-[3px] tw-mt-4 tw-w-full tw-bg-[#b4b4b4]"
}
const _hoisted_4 = { class: "tw-px-[5em] tw-mt-4 tw-mb-[50px]" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "btn-list-users tw-flex tw-justify-end tw-mb-4" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn tw-flex tw-items-center tw-text-[#FFFFFF] tw-bg-[#00A0DA] tw-rounded-full",
    "data-bs-toggle": "modal",
    "data-bs-target": "#exampleModalUsers"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-users tw-text-[#FFFFFF] tw-text-[30px] tw-pr-3" }),
    /*#__PURE__*/_createTextVNode(" SEE ECONOMIC SHEET ")
  ])
], -1)
const _hoisted_6 = {
  class: "modal fade modal-xl",
  id: "exampleModalUsers",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_7 = { class: "modal-dialog" }
const _hoisted_8 = { class: "modal-content" }
const _hoisted_9 = { class: "modal-header" }
const _hoisted_10 = {
  key: 0,
  class: "comment-box"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "\"Action.\"", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, "\"Watch Scenario.\"", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close custom-close-button",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
], -1)
const _hoisted_15 = { class: "modal-body" }
const _hoisted_16 = {
  key: 0,
  class: "table-mlo w-100 bg-white p-3 rounded-4"
}
const _hoisted_17 = { class: "tw-flex tw-gap-3" }
const _hoisted_18 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Name", -1)
const _hoisted_20 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PhoneNumber", -1)
const _hoisted_22 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Date", -1)
const _hoisted_24 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "E-MAIL"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PHONE NUMBER"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CREATION DATE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ACTION")
  ])
], -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "5",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  class: "modal fade modal-xl",
  id: "exampleModal4858",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel4858",
  "aria-hidden": "true"
}
const _hoisted_34 = { class: "modal-dialog" }
const _hoisted_35 = { class: "modal-content" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_37 = { class: "modal-body" }
const _hoisted_38 = { class: "tw-bg-white tw-w-full tw-rounded-bl-3xl tw-rounded-br-3xl tw-px-7 tw-py-5 tw-flex-col gap-y-" }
const _hoisted_39 = { class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4" }
const _hoisted_40 = { class: "tw-flex tw-justify-start gap-3 tw-w-full" }
const _hoisted_41 = {
  key: 0,
  class: "table-mlo w-100 bg-white p-3 rounded-4"
}
const _hoisted_42 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CODE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "DATE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SECTION"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCENARIO"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "WATCH SCENARIO")
  ])
], -1)
const _hoisted_44 = { key: 0 }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { key: 1 }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "4",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = /*#__PURE__*/_createStaticVNode("<div class=\"container d-flex justify-content-center pb-3\"><button id=\"openNoteModalInvestement\" class=\"btn tw-bg-[#FF0000] tw-text-[#FFFFFF] tw-rounded-lg fw-bold btn-sm\" style=\"border:none;\" data-bs-toggle=\"modal\" data-bs-target=\"#note-Modal-Investement\"> SEE NOTE </button></div><div class=\"modal\" id=\"note-Modal-Investement\" tabindex=\"-1\" aria-hidden=\"true\" aria-labelledby=\"label-modal-1\"><div class=\"modal-dialog modal-dialog-centered\"><div class=\"modal-content\"><div class=\"modal-body\"><h3 class=\"text-center\"><b>Note:</b></h3><br><p class=\"text-center\">Before entering information in the &quot;Financing Information&quot; section, make sure to first complete and save the &quot;Realtor Form&quot; and &quot;Title Company&quot; sections. </p><br><div class=\"d-flex justify-content-end\"><button id=\"closeNoteModal\" type=\"button\" class=\"btn tw-bg-[#00a0da] tw-text-[#FFFFFF] tw-rounded-full tw-w-[150px]\" data-bs-dismiss=\"modal\" aria-label=\"Close\"> CLose </button></div></div></div></div></div>", 2)
const _hoisted_53 = { class: "tw-bg-white tw-rounded-xl tw-p-4" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-text-center tw-text-lg tw-text-[20px] tw-border-b-[2px] tw-border-[#b0b0b0] tw-pb-2" }, " PASSIVE INVESTMENT", -1)
const _hoisted_55 = { class: "tw-flex tw-justify-between tw-items-center tw-gap-5 tw-mt-3" }
const _hoisted_56 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("button", {
  class: "tw-bg-[#00a0da] tw-rounded-full tw-w-full tw-border-none tw-flex tw-justify-center tw-items-center tw-h-[40px] tw-gap-2 tw-text-white tw-font-light",
  "data-bs-toggle": "collapse",
  href: "#collapseExampleFlipTittle",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "collapseExample"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-h-[20px] tw-w-[20px] tw-grayscale-0 tw-invert tw-brightness-0",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("b", null, "TITLE COMPANY     ▼")
], -1)
const _hoisted_58 = {
  class: "collapse",
  id: "collapseExampleFlipTittle"
}
const _hoisted_59 = { class: "card card-body tw-px-[80px]" }
const _hoisted_60 = {
  class: "tw-px-[30px]",
  style: {"border":"1px solid #b0b0b0"}
}
const _hoisted_61 = { class: "tw-flex tw-justify-around mt-3 mb-3" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_63 = { class: "pb-3" }
const _hoisted_64 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "CLOSING CLOSE"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "OTHER PRICE")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "1"
    }, "BUYER"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "1"
    }, "SELLER"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "1"
    }, [
      /*#__PURE__*/_createTextVNode("SEARCH TITLE "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" COMPANY")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "1"
    }, "CHAIN TITTLE")
  ])
], -1)
const _hoisted_66 = {
  key: 0,
  class: "data"
}
const _hoisted_67 = ["onClick"]
const _hoisted_68 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("button", {
  class: "tw-bg-[#00a0da] tw-rounded-full tw-w-full tw-border-none tw-flex tw-justify-center tw-items-center tw-h-[40px] tw-gap-2 tw-text-white tw-font-light",
  "data-bs-toggle": "collapse",
  href: "#collapseExample88",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "collapseExample"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-h-[20px] tw-w-[20px] tw-grayscale-0 tw-invert tw-brightness-0",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("b", null, "INSPECTOR     ▼")
], -1)
const _hoisted_70 = {
  class: "collapse",
  id: "collapseExample88"
}
const _hoisted_71 = { class: "card card-body" }
const _hoisted_72 = { class: "tw-flex tw-justify-around" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("button", { class: "tw-bg-[#00a0da] tw-px-11 tw-mt-2 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[180px]" }, "GET IT", -1)
const _hoisted_75 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " MORTGAGE LOAN ORIGINATOR", -1)
const _hoisted_77 = { class: "tw-px-4" }
const _hoisted_78 = { class: "tw-flex tw-justify-between tw-items-center tw-mt-3 tw-gap-5 tw-text-left" }
const _hoisted_79 = {
  key: 0,
  class: "tw-w-full"
}
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PROPERTY", -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("option", { value: null }, "SELECT PROPERTY", -1)
const _hoisted_82 = ["value"]
const _hoisted_83 = {
  key: 1,
  class: "tw-w-full"
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "SCORE CREDIT", -1)
const _hoisted_85 = {
  key: 2,
  class: "tw-w-full"
}
const _hoisted_86 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PROGRAM", -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("option", { value: null }, "SELECT PROGRAM", -1)
const _hoisted_88 = ["value"]
const _hoisted_89 = { class: "tw-w-full" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "YEARS", -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("option", { value: null }, "SELECT YEAR", -1)
const _hoisted_92 = ["value"]
const _hoisted_93 = { class: "tw-flex tw-items-center tw-justify-center tw-mt-5 tw-gap-5 tw-text-left tw-mb-5" }
const _hoisted_94 = ["disabled"]
const _hoisted_95 = { class: "tw-mt-4 tw-mb-12" }
const _hoisted_96 = { class: "tw-w-full table-edit" }
const _hoisted_97 = ["colspan"]
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-justify-center tw-text-white tw-text-base tw-py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "tw-text-[13px]" }, "PERSONAL DATA")
], -1)
const _hoisted_99 = [
  _hoisted_98
]
const _hoisted_100 = { key: 0 }
const _hoisted_101 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " NAME ", -1)
const _hoisted_103 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_104 = { key: 0 }
const _hoisted_105 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PHONE NUMBER", -1)
const _hoisted_107 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_108 = { key: 0 }
const _hoisted_109 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " EMAIL", -1)
const _hoisted_111 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_112 = { key: 0 }
const _hoisted_113 = {
  key: 0,
  class: "tw-even:bg-[#eaeaea] tw-odd:bg-white"
}
const _hoisted_114 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_115 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_116 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " INTERES RATE", -1)
const _hoisted_118 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_119 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_120 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_121 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_122 = {
  key: 1,
  class: "tw-even:bg-[#eaeaea] tw-odd:bg-white"
}
const _hoisted_123 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PMI", -1)
const _hoisted_124 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_125 = {
  key: 2,
  class: "tw-even:bg-[#eaeaea] tw-odd:bg-white"
}
const _hoisted_126 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " BACK END RATIO D&I", -1)
const _hoisted_127 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_128 = {
  key: 3,
  class: "tw-even:bg-[#eaeaea] tw-odd:bg-white"
}
const _hoisted_129 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " MAXIMUM LOAN NOT JUMBO", -1)
const _hoisted_130 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_131 = { class: "tw-w-full table-edit tw-shadow-none tw-border-none tw-mt-2" }
const _hoisted_132 = { class: "tw-[&>td]:border-r-0" }
const _hoisted_133 = /*#__PURE__*/_createElementVNode("td", { class: "tw-border-none" }, null, -1)
const _hoisted_134 = { class: "tw-border-none tw-px-4" }
const _hoisted_135 = ["onClick"]
const _hoisted_136 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " CUSTOMER INFORMATION ", -1)
const _hoisted_138 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_139 = { class: "tw-flex tw-justify-between tw-items-center tw-mt-3 tw-gap-5" }
const _hoisted_140 = { class: "tw-w-full" }
const _hoisted_141 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "NAME", -1)
const _hoisted_142 = { class: "tw-w-full" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PHONE NUMBER", -1)
const _hoisted_144 = { class: "tw-w-full" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "EMAIL", -1)
const _hoisted_146 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_147 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " PROPERTY INFORMATION ", -1)
const _hoisted_148 = { class: "tw-px-4" }
const _hoisted_149 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_150 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " TYPE OF PROPERTY ", -1)
const _hoisted_152 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_153 = { class: "tw-flex tw-justify-between tw-items-center tw-gap-10" }
const _hoisted_154 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select", -1)
const _hoisted_155 = ["value"]
const _hoisted_156 = ["value"]
const _hoisted_157 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_158 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY ADDRESSES ", -1)
const _hoisted_159 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_160 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_161 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " FINANCING INFORMATION ", -1)
const _hoisted_162 = { class: "tw-px-4" }
const _hoisted_163 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_164 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_165 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY PRICE ", -1)
const _hoisted_166 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_167 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_168 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " DOWN PAYMENT ", -1)
const _hoisted_169 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_170 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_171 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN AMOUNT ", -1)
const _hoisted_172 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_173 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_174 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " INTEREST RATE ", -1)
const _hoisted_175 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_176 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_177 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN YEARS ", -1)
const _hoisted_178 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_179 = {
  key: 0,
  class: "tw-even:bg-gray-50 tw-odd:bg-white"
}
const _hoisted_180 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN PROGRAM ", -1)
const _hoisted_181 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_182 = {
  key: 1,
  class: "tw-even:bg-gray-50 tw-odd:bg-white"
}
const _hoisted_183 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PMI ", -1)
const _hoisted_184 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_185 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_186 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY TAXES", -1)
const _hoisted_187 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_188 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_189 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY INSURANCE", -1)
const _hoisted_190 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_191 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_192 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " FEDERAL TAX", -1)
const _hoisted_193 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_194 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_195 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " FLOOD INSURANCE", -1)
const _hoisted_196 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_197 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_198 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ASSOCIATION PAYMENT ", -1)
const _hoisted_199 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_200 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_201 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " OTHERS MONTHLY PAYMENT ", -1)
const _hoisted_202 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_203 = { class: "tw-flex tw-items-center tw-justify-center tw-mt-5 tw-gap-5 tw-text-left tw-mb-8" }
const _hoisted_204 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-px-14" }
const _hoisted_205 = { class: "tw-flex tw-justify-end" }
const _hoisted_206 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_207 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, "MONTHLY PAYMENT ", -1)
const _hoisted_208 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_209 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " CLOSING COST, BROKER AND COMMISSIONS ", -1)
const _hoisted_210 = { class: "tw-px-4" }
const _hoisted_211 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_212 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_213 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " CLOSING COST ", -1)
const _hoisted_214 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_215 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_216 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " BROKER PAYMENT ", -1)
const _hoisted_217 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_218 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_219 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " INCOME ", -1)
const _hoisted_220 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_221 = { class: "tw-flex tw-justify-between tw-items-center tw-mt-3 tw-gap-5" }
const _hoisted_222 = { class: "tw-w-full" }
const _hoisted_223 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "INCOME MONTHLY RENT", -1)
const _hoisted_224 = { class: "tw-w-full" }
const _hoisted_225 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "ESTIMATE CAPITAL GAIN OR PLUSVALIA ", -1)
const _hoisted_226 = ["value"]
const _hoisted_227 = { class: "tw-flex tw-justify-center tw-gap-[20px] tw-pb-5" }
const _hoisted_228 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-mt-4 tw-px-14" }
const _hoisted_229 = { class: "tw-flex tw-justify-end" }
const _hoisted_230 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_231 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, "TOTAL INVESTMENT ", -1)
const _hoisted_232 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-mt-4 tw-px-14" }
const _hoisted_233 = { class: "tw-flex tw-justify-end" }
const _hoisted_234 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_235 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " NET PROFIT 5 YEARS (%) ", -1)
const _hoisted_236 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-7 tw-gap-5 tw-mb-5 tw-w-full" }
const _hoisted_237 = ["disabled"]
const _hoisted_238 = {
  class: "modal fade modal-xl",
  id: "exampleModalEscenarioShortTerm",
  tabindex: "-1",
  "aria-labelledby": "exampleModalEscenarioShortTerm",
  "aria-hidden": "true"
}
const _hoisted_239 = { class: "modal-dialog" }
const _hoisted_240 = { class: "modal-content" }
const _hoisted_241 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_242 = { class: "modal-body" }
const _hoisted_243 = { class: "tw-flex tw-justify-end tw-gap-[40px] tw-pr-7" }
const _hoisted_244 = { class: "tw-bg-[#00a0da] tw-px-5 tw-py-1 tw-rounded-full tw-text-[#ffffff]" }
const _hoisted_245 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print tw-text-[#FFFFFF] tw-pr-2" }, null, -1)
const _hoisted_246 = { class: "tw-bg-[#00a0da] tw-px-5 tw-py-1 tw-rounded-full tw-text-[#ffffff]" }
const _hoisted_247 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope tw-text-[#FFFFFF] tw-text-[18px] tw-pr-2" }, null, -1)
const _hoisted_248 = /*#__PURE__*/_createElementVNode("section", { slot: "pdf-content" }, null, -1)
const _hoisted_249 = {
  class: "tw-bg-white tw-w-full tw-rounded-bl-3xl tw-rounded-br-3xl tw-px-7 tw-py-5 tw-flex-col gap-y-",
  id: "printable-target"
}
const _hoisted_250 = /*#__PURE__*/_createElementVNode("h1", { class: "pb-4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createTextVNode("PASIVE FINANCING"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" PROFIT OF ESTIMATED COST/BENEFITS")
  ])
], -1)
const _hoisted_251 = { class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4" }
const _hoisted_252 = {
  key: 0,
  class: "tw-flex tw-justify-start gap-3 tw-w-full"
}
const _hoisted_253 = { class: "table-mlo w-100 bg-white rounded-4" }
const _hoisted_254 = { class: "table table-bordered border-0 mb-3 table-edit table-no-radius" }
const _hoisted_255 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, "MORTGAGE LOAN ORIGINATOR")
  ])
], -1)
const _hoisted_256 = { class: "data" }
const _hoisted_257 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY", -1)
const _hoisted_258 = { class: "data" }
const _hoisted_259 = /*#__PURE__*/_createElementVNode("td", null, "SCORE-CREDIT", -1)
const _hoisted_260 = { class: "data" }
const _hoisted_261 = /*#__PURE__*/_createElementVNode("td", null, "PROGRAM", -1)
const _hoisted_262 = { class: "data" }
const _hoisted_263 = /*#__PURE__*/_createElementVNode("td", null, "YEARS", -1)
const _hoisted_264 = { class: "data" }
const _hoisted_265 = /*#__PURE__*/_createElementVNode("td", null, "NAME", -1)
const _hoisted_266 = { class: "data" }
const _hoisted_267 = /*#__PURE__*/_createElementVNode("td", null, "PHONE-NUMBER-MLO", -1)
const _hoisted_268 = { class: "data" }
const _hoisted_269 = /*#__PURE__*/_createElementVNode("td", null, "FHA", -1)
const _hoisted_270 = { class: "data" }
const _hoisted_271 = /*#__PURE__*/_createElementVNode("td", null, "INTEREST-RATE", -1)
const _hoisted_272 = { class: "data" }
const _hoisted_273 = /*#__PURE__*/_createElementVNode("td", null, "MINUMUM-DOWN-PAYMENT-LOWER", -1)
const _hoisted_274 = { class: "data" }
const _hoisted_275 = /*#__PURE__*/_createElementVNode("td", null, "MINUMUM-DOWN-PAYMENT-HIGHER", -1)
const _hoisted_276 = { class: "data" }
const _hoisted_277 = /*#__PURE__*/_createElementVNode("td", null, "PMI", -1)
const _hoisted_278 = { class: "data" }
const _hoisted_279 = /*#__PURE__*/_createElementVNode("td", null, "BACK-END-RATIO-D&I", -1)
const _hoisted_280 = { class: "data" }
const _hoisted_281 = /*#__PURE__*/_createElementVNode("td", null, "MAXIMUM-LOAN-NOT-JUMBO", -1)
const _hoisted_282 = { class: "table table-bordered border-0 mb-3 table-edit table-no-radius" }
const _hoisted_283 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, "CUSTOMER INFORMATION ")
  ])
], -1)
const _hoisted_284 = { class: "data" }
const _hoisted_285 = /*#__PURE__*/_createElementVNode("td", null, "NAME", -1)
const _hoisted_286 = { class: "data" }
const _hoisted_287 = /*#__PURE__*/_createElementVNode("td", null, "PHONE-NUMBER", -1)
const _hoisted_288 = { class: "data" }
const _hoisted_289 = /*#__PURE__*/_createElementVNode("td", null, "EMAIL", -1)
const _hoisted_290 = { class: "table table-bordered border-0 mb-3 table-edit table-no-radius" }
const _hoisted_291 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, "PROPERTY INFORMATION ")
  ])
], -1)
const _hoisted_292 = { class: "data" }
const _hoisted_293 = /*#__PURE__*/_createElementVNode("td", null, "TYPE-OF-PROPERTY", -1)
const _hoisted_294 = { class: "data" }
const _hoisted_295 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY-ADDRESSES", -1)
const _hoisted_296 = { class: "table table-bordered border-0 mb-3 table-edit table-no-radius" }
const _hoisted_297 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, " FINANCIAL-INFORMATION")
  ])
], -1)
const _hoisted_298 = { class: "data" }
const _hoisted_299 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY-PRICE", -1)
const _hoisted_300 = { class: "data" }
const _hoisted_301 = /*#__PURE__*/_createElementVNode("td", null, "DOWN-PAYMENT", -1)
const _hoisted_302 = { class: "data" }
const _hoisted_303 = /*#__PURE__*/_createElementVNode("td", null, "LOAN-AMOUNT", -1)
const _hoisted_304 = { class: "data" }
const _hoisted_305 = /*#__PURE__*/_createElementVNode("td", null, "INTEREST-RATE", -1)
const _hoisted_306 = { class: "data" }
const _hoisted_307 = /*#__PURE__*/_createElementVNode("td", null, "LOAN-YEARS", -1)
const _hoisted_308 = { class: "data" }
const _hoisted_309 = /*#__PURE__*/_createElementVNode("td", null, "LOAN-PROGRAM", -1)
const _hoisted_310 = { class: "data" }
const _hoisted_311 = /*#__PURE__*/_createElementVNode("td", null, "PMI-OR-MIP", -1)
const _hoisted_312 = { class: "data" }
const _hoisted_313 = /*#__PURE__*/_createElementVNode("td", null, "MONTHLY-PAYMENT", -1)
const _hoisted_314 = { class: "table table-bordered border-0 mb-3 table-edit table-no-radius" }
const _hoisted_315 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, "CLOSING COST, BROKER AND COMMISSIONS ")
  ])
], -1)
const _hoisted_316 = { class: "data" }
const _hoisted_317 = /*#__PURE__*/_createElementVNode("td", null, "CLOSING-COST", -1)
const _hoisted_318 = { class: "data" }
const _hoisted_319 = /*#__PURE__*/_createElementVNode("td", null, "BROKER-PAYMENT", -1)
const _hoisted_320 = { class: "table table-bordered border-0 mb-0 table-edit table-no-radius" }
const _hoisted_321 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, "INCOME")
  ])
], -1)
const _hoisted_322 = { class: "data" }
const _hoisted_323 = /*#__PURE__*/_createElementVNode("td", null, "AVEAGE-ANNUAL-NET-PROFIT (%)", -1)
const _hoisted_324 = { class: "data" }
const _hoisted_325 = /*#__PURE__*/_createElementVNode("td", null, "ANNUAL-AVERAGE %-NET-PROFIT-5-YEARS", -1)
const _hoisted_326 = /*#__PURE__*/_createElementVNode("div", { class: "px-5 pb-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "tw-font-medium tw-text-[18px]" }, "Note:"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" The investment outcome presented here is an estimate subject to potential "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" fluctuations arising from the execution of the project. ")
  ])
], -1)
const _hoisted_327 = {
  class: "modal fade",
  id: "exampleModalMessage",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_328 = { class: "modal-dialog" }
const _hoisted_329 = { class: "content-mensage modal-content tw-bg-[#E6E7E8]" }
const _hoisted_330 = /*#__PURE__*/_createElementVNode("div", { class: "boton-mensage modal-header tw-flex tw-items-center tw-outline-none tw-bg-[#00a0da] tw-border-[#00a0da] tw-bordered-[20px]" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title tw-text-white tw-text-xl",
    id: "exampleModalLabel"
  }, "New Message"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle tw-text-[25px] tw-text-white" })
  ])
], -1)
const _hoisted_331 = { class: "modal-body" }
const _hoisted_332 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_333 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "USER-EMAIL: ", -1)
const _hoisted_334 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_335 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "SUBJECT: ", -1)
const _hoisted_336 = { class: "tw-mt-5 tw-w-full tw-flex tw-justify-center tw-items-center" }
const _hoisted_337 = /*#__PURE__*/_createElementVNode("div", { class: "tw-pl-5" }, null, -1)
const _hoisted_338 = { class: "modal-footer tw-flex tw-items-center tw-justify-between" }
const _hoisted_339 = { class: "tw-flex tw-justify-start tw-items-center" }
const _hoisted_340 = {
  key: 0,
  class: "btn-attach tw-bg-[#E6E7E8] tw-h-[40px] tw-font-bold tw-px-4 tw-rounded-full tw-text-xl"
}
const _hoisted_341 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paperclip tw-text-gray-500" }, null, -1)
const _hoisted_342 = { class: "tw-flex tw-justify-end tw-items-center" }
const _hoisted_343 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_ResidentialView = _resolveComponent("ResidentialView")!
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_VueNumberFormat = _resolveComponent("VueNumberFormat")!
  const _component_vue3_html2pdf = _resolveComponent("vue3-html2pdf")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.header === null)
        ? (_openBlock(), _createBlock(_component_TopBar, {
            key: 0,
            helpBar: true,
            helpDescription: "Video tutorial for the use of the ''PASIVE FINANCING''",
            helpVideo: "https://www.realtortools.org/media/Video%20Passive%20Financing.mp4"
          }))
        : _createCommentVNode("", true),
      (!_ctx.foreign)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_ResidentialView, {
              header: false,
              onRealtorEvent: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeRealtor($event)))
            })
          ]))
        : _createCommentVNode("", true),
      (!_ctx.foreign)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    id: "openNoteModal1",
                    class: "btn tw-bg-[#FF0000] tw-text-[#FFFFFF] tw-rounded-lg fw-bold btn-sm",
                    style: {"border":"none"},
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleComment && _ctx.toggleComment(...args)))
                  }, " SEE NOTE "),
                  (_ctx.isCommentVisible)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createTextVNode(" You can find the Economic Sheet by: Name, Phone Number, or Date."),
                        _hoisted_11,
                        _createTextVNode("Then, to filter, click on "),
                        _hoisted_12,
                        _createTextVNode(" On the new screen, click on "),
                        _hoisted_13
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_14
              ]),
              _createElementVNode("div", _hoisted_15, [
                (_ctx.scenario.users)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _withDirectives(_createElementVNode("input", {
                            name: "",
                            id: "",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.scenario.users.name) = $event)),
                            class: "tw-w-full tw-outline-none tw-h-[38px] tw-border tw-border-[#dddddd] tw-rounded-lg tw-overflow-hidden tw-px-4"
                          }, null, 512), [
                            [_vModelText, _ctx.params.scenario.users.name]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _withDirectives(_createElementVNode("input", {
                            name: "",
                            id: "",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.scenario.users.phonenumber) = $event)),
                            class: "tw-w-full tw-outline-none tw-h-[38px] tw-border tw-border-[#dddddd] tw-rounded-lg tw-overflow-hidden tw-px-4"
                          }, null, 512), [
                            [_vModelText, _ctx.params.scenario.users.phonenumber]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createVNode(_component_datepicker, {
                            "auto-apply": "",
                            class: "w-100",
                            range: "",
                            modelValue: _ctx.configDatePicker.date,
                            "onUpdate:modelValue": [
                              _cache[4] || (_cache[4] = ($event: any) => ((_ctx.configDatePicker.date) = $event)),
                              _ctx.changeDate
                            ],
                            placeholder: "Enter date range..."
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getScenarioUsers())),
                        class: "mb-3 tw-bg-[#00a0da] tw-text-white tw-h-[35px] tw-font-bold tw-w-[150px] tw-rounded-full tw-text-[18px]"
                      }, "Filter"),
                      _createElementVNode("table", _hoisted_24, [
                        _hoisted_25,
                        (_ctx.scenario.users.results.length > 0)
                          ? (_openBlock(), _createElementBlock("tbody", _hoisted_26, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenario.users.results, (user) => {
                                return (_openBlock(), _createElementBlock("tr", null, [
                                  _createElementVNode("td", null, _toDisplayString(user.user_name), 1),
                                  _createElementVNode("td", null, _toDisplayString(user.user_email), 1),
                                  _createElementVNode("td", null, _toDisplayString(user.user_phonenumber), 1),
                                  _createElementVNode("td", null, _toDisplayString(user.create_date), 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("a", {
                                      "data-bs-toggle": "modal",
                                      "data-bs-target": "#exampleModal4858",
                                      href: "#",
                                      onClick: ($event: any) => (_ctx.loadScenarios(user))
                                    }, _hoisted_29, 8, _hoisted_27)
                                  ])
                                ]))
                              }), 256))
                            ]))
                          : (_openBlock(), _createElementBlock("tbody", _hoisted_30, _hoisted_32))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      (_ctx.scenario.userScenarios)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _createElementVNode("table", _hoisted_42, [
                              _hoisted_43,
                              (_ctx.scenario.userScenarios.results && _ctx.scenario.userScenarios.results.length > 0)
                                ? (_openBlock(), _createElementBlock("tbody", _hoisted_44, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenario.userScenarios.results, (userscenario) => {
                                      return (_openBlock(), _createElementBlock("tr", null, [
                                        _createElementVNode("td", null, _toDisplayString(userscenario.code), 1),
                                        _createElementVNode("td", null, _toDisplayString(userscenario.date), 1),
                                        _createElementVNode("td", null, _toDisplayString(userscenario.type), 1),
                                        _createElementVNode("td", null, _toDisplayString(userscenario.type_name), 1),
                                        _createElementVNode("td", null, [
                                          _createElementVNode("a", {
                                            "data-bs-toggle": "modal",
                                            "data-bs-target": "#exampleModalEscenarioShortTerm",
                                            href: "#",
                                            onClick: ($event: any) => (_ctx.loadScenario(userscenario))
                                          }, _hoisted_47, 8, _hoisted_45)
                                        ])
                                      ]))
                                    }), 256))
                                  ]))
                                : (_openBlock(), _createElementBlock("tbody", _hoisted_48, _hoisted_50))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _hoisted_51,
        _createElementVNode("div", _hoisted_53, [
          _hoisted_54,
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _hoisted_57,
              _createElementVNode("div", _hoisted_58, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTitleCompanies, (user) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", null, _toDisplayString(user.companyname), 1),
                          _createTextVNode(),
                          _hoisted_62
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("table", _hoisted_64, [
                          _hoisted_65,
                          _createElementVNode("tbody", null, [
                            (user.tables[0] !== undefined)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_66, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.tables[0].tabledata[0].data, (tabledata) => {
                                    return (_openBlock(), _createElementBlock("td", null, _toDisplayString(tabledata.table_closing_close) + "%", 1))
                                  }), 256)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.tables[0].tabledata[1].data, (tabledata) => {
                                    return (_openBlock(), _createElementBlock("td", null, _toDisplayString(tabledata.table_each_tittle_review), 1))
                                  }), 256))
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("button", {
                          class: "tw-bg-[#00a0da] tw-px-11 tw-mt-4 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[180px]",
                          onClick: ($event: any) => (_ctx.getItTitleCompany(user))
                        }, "GET IT", 8, _hoisted_67)
                      ])
                    ])
                  ]))
                }), 256))
              ])
            ]),
            _createElementVNode("div", _hoisted_68, [
              _hoisted_69,
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listInspectors, (user) => {
                      return (_openBlock(), _createElementBlock("div", null, [
                        _createElementVNode("span", null, _toDisplayString(user.username + " " + user.lastname), 1),
                        _createTextVNode(),
                        _hoisted_73,
                        _hoisted_74
                      ]))
                    }), 256))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_75, [
            _hoisted_76,
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                (!_ctx.foreign)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                      _hoisted_80,
                      _withDirectives(_createElementVNode("select", {
                        name: "",
                        id: "",
                        class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.property) = $event))
                      }, [
                        _hoisted_81,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTablePropertiesMlo, (tabletype) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: tabletype.id
                          }, _toDisplayString(tabletype.name), 9, _hoisted_82))
                        }), 256))
                      ], 512), [
                        [_vModelSelect, _ctx.filters.property]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.foreign)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                      _hoisted_84,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.score) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.filters.score]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.foreign)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                      _hoisted_86,
                      _withDirectives(_createElementVNode("select", {
                        name: "",
                        id: "",
                        class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.program) = $event))
                      }, [
                        _hoisted_87,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listPrograms, (program) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            (program.name == 'CONVENTIONAL')
                              ? (_openBlock(), _createElementBlock("option", {
                                  key: 0,
                                  value: program.id
                                }, _toDisplayString(program.name), 9, _hoisted_88))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 256))
                      ], 512), [
                        [_vModelSelect, _ctx.filters.program]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_89, [
                  _hoisted_90,
                  _withDirectives(_createElementVNode("select", {
                    name: "",
                    id: "",
                    class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters.year) = $event))
                  }, [
                    _hoisted_91,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listYears, (year) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: year.id
                      }, _toDisplayString(year.name), 9, _hoisted_92))
                    }), 256))
                  ], 512), [
                    [_vModelSelect, _ctx.filters.year]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_93, [
                _createElementVNode("button", {
                  class: "tw-bg-[#00a0da] disabled:tw-bg-[#ccc] tw-px-11 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[200px]",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.filterTable && _ctx.filterTable(...args))),
                  disabled: _ctx.listMlos.length == 0
                }, "RUN", 8, _hoisted_94)
              ]),
              _createElementVNode("div", _hoisted_95, [
                _createElementVNode("table", _hoisted_96, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        class: "tw-bg-[#00a0da] tw-rounded-tl-2xl tw-rounded-tr-2xl",
                        colspan: _ctx.listMlos.length + 1
                      }, _hoisted_99, 8, _hoisted_97)
                    ])
                  ]),
                  (_ctx.listMlos.length > 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_100, [
                        _createElementVNode("tr", _hoisted_101, [
                          _hoisted_102,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMlos, (user) => {
                            return (_openBlock(), _createElementBlock("td", _hoisted_103, [
                              (_ctx.filters.active)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_104, _toDisplayString(user.username +
                                                " " + user.lastname), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 256))
                        ]),
                        _createElementVNode("tr", _hoisted_105, [
                          _hoisted_106,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMlos, (user) => {
                            return (_openBlock(), _createElementBlock("td", _hoisted_107, [
                              (_ctx.filters.active)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_108, _toDisplayString(user.phonenumber), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 256))
                        ]),
                        _createElementVNode("tr", _hoisted_109, [
                          _hoisted_110,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMlos, (user) => {
                            return (_openBlock(), _createElementBlock("td", _hoisted_111, [
                              (_ctx.filters.active)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_112, _toDisplayString(user.email), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 256))
                        ]),
                        (!_ctx.foreign)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_113, [
                              _createElementVNode("td", _hoisted_114, _toDisplayString(_ctx.filters.program_name), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMlos, (user) => {
                                return (_openBlock(), _createElementBlock("td", _hoisted_115, _toDisplayString(user.fha), 1))
                              }), 256))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("tr", _hoisted_116, [
                          _hoisted_117,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMlos, (user) => {
                            return (_openBlock(), _createElementBlock("td", _hoisted_118, _toDisplayString(user.interes_rate && user.interes_rate != "-" ?
                                            user.interes_rate + "%" : "-"), 1))
                          }), 256))
                        ]),
                        _createElementVNode("tr", _hoisted_119, [
                          _createElementVNode("td", _hoisted_120, _toDisplayString(_ctx.foreign ? "DOWN PAYMENT" : "MINIMUM DOWN PAYMENT"), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMlos, (user) => {
                            return (_openBlock(), _createElementBlock("td", _hoisted_121, _toDisplayString(user.minimum_down_payment &&
                                            user.minimum_down_payment != "-" ? user.minimum_down_payment + "%" : "-"), 1))
                          }), 256))
                        ]),
                        (!_ctx.foreign)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_122, [
                              _hoisted_123,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMlos, (user) => {
                                return (_openBlock(), _createElementBlock("td", _hoisted_124, _toDisplayString(user.average_mip_pmi), 1))
                              }), 256))
                            ]))
                          : _createCommentVNode("", true),
                        (!_ctx.foreign)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_125, [
                              _hoisted_126,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMlos, (user) => {
                                return (_openBlock(), _createElementBlock("td", _hoisted_127, _toDisplayString(user.backend_ratio), 1))
                              }), 256))
                            ]))
                          : _createCommentVNode("", true),
                        (!_ctx.foreign)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_128, [
                              _hoisted_129,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMlos, (user) => {
                                return (_openBlock(), _createElementBlock("td", _hoisted_130, _toDisplayString(user.maximum_loan ? ('' + _ctx.commaFormat(user.maximum_loan)) : ''), 1))
                              }), 256))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("table", _hoisted_131, [
                  _createElementVNode("tr", _hoisted_132, [
                    _hoisted_133,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMlos, (user) => {
                      return (_openBlock(), _createElementBlock("td", _hoisted_134, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.loadData(user)),
                          class: "tw-bg-[#00a0da] tw-px-11 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-mt-5"
                        }, "GET IT", 8, _hoisted_135)
                      ]))
                    }), 256))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_136, [
            _hoisted_137,
            _createElementVNode("div", _hoisted_138, [
              _createElementVNode("div", _hoisted_139, [
                _createElementVNode("div", _hoisted_140, [
                  _hoisted_141,
                  _withDirectives(_createElementVNode("input", {
                    name: "",
                    id: "",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.customer.name) = $event)),
                    placeholder: "Complete name",
                    class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                  }, null, 512), [
                    [_vModelText, _ctx.customer.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_142, [
                  _hoisted_143,
                  _withDirectives(_createElementVNode("input", {
                    name: "",
                    id: "",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.customer.phone) = $event)),
                    placeholder: "9999999999",
                    class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                  }, null, 512), [
                    [_vModelText, _ctx.customer.phone]
                  ])
                ]),
                _createElementVNode("div", _hoisted_144, [
                  _hoisted_145,
                  _withDirectives(_createElementVNode("input", {
                    name: "",
                    id: "",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.customer.email) = $event)),
                    placeholder: "example@gmail.com",
                    class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                  }, null, 512), [
                    [_vModelText, _ctx.customer.email]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_146, [
            _hoisted_147,
            _createElementVNode("div", _hoisted_148, [
              _createElementVNode("table", _hoisted_149, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", _hoisted_150, [
                    _hoisted_151,
                    _createElementVNode("td", _hoisted_152, [
                      _createElementVNode("div", _hoisted_153, [
                        _withDirectives(_createElementVNode("select", {
                          name: "",
                          id: "",
                          class: "form-control tw-full",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.financialInformation.propertyType) = $event)),
                          onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.calculatePropertyEstimateCapitalGain && _ctx.calculatePropertyEstimateCapitalGain(...args)))
                        }, [
                          _hoisted_154,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listPropertyTypes, (property) => {
                            return (_openBlock(), _createElementBlock("option", { value: property }, _toDisplayString(property.name), 9, _hoisted_155))
                          }), 256))
                        ], 544), [
                          [_vModelSelect, _ctx.financialInformation.propertyType]
                        ]),
                        (_ctx.financialInformation.propertyType)
                          ? (_openBlock(), _createElementBlock("input", {
                              key: 0,
                              type: "text",
                              value: (_ctx.financialInformation.propertyType.text ? (_ctx.financialInformation.propertyType.text * 100) + '%' : ''),
                              disabled: ""
                            }, null, 8, _hoisted_156))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_157, [
                    _hoisted_158,
                    _createElementVNode("td", _hoisted_159, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.financialInformation.propertyAddresses) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.financialInformation.propertyAddresses]
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_160, [
            _hoisted_161,
            _createElementVNode("div", _hoisted_162, [
              _createElementVNode("table", _hoisted_163, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", _hoisted_164, [
                    _hoisted_165,
                    _createElementVNode("td", _hoisted_166, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "propertyPrice",
                        value: _ctx.financialInformation.propertyPrice,
                        "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.financialInformation.propertyPrice) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' },
                        onChange: _ctx.calculatePropertyEstimateCapitalGain
                      }, null, 8, ["value", "options", "onChange"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_167, [
                    _hoisted_168,
                    _createElementVNode("td", _hoisted_169, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "propertyDownPayment",
                        value: _ctx.financialInformation.propertyDownPayment,
                        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.financialInformation.propertyDownPayment) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_170, [
                    _hoisted_171,
                    _createElementVNode("td", _hoisted_172, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "propertyEstimateLoan",
                        value: _ctx.financialInformation.propertyEstimateLoan,
                        "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.financialInformation.propertyEstimateLoan) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: true, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_173, [
                    _hoisted_174,
                    _createElementVNode("td", _hoisted_175, _toDisplayString(_ctx.selection.selectedUser ? _ctx.selection.selectedUser.interes_rate : ''), 1)
                  ]),
                  _createElementVNode("tr", _hoisted_176, [
                    _hoisted_177,
                    _createElementVNode("td", _hoisted_178, _toDisplayString(_ctx.selection.selectedYears ? _ctx.selection.selectedYears.name : ''), 1)
                  ]),
                  (!_ctx.foreign)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_179, [
                        _hoisted_180,
                        _createElementVNode("td", _hoisted_181, _toDisplayString(_ctx.selection.selectedProgram ? _ctx.selection.selectedProgram.name : ''), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.foreign)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_182, [
                        _hoisted_183,
                        _createElementVNode("td", _hoisted_184, " $ " + _toDisplayString(_ctx.pmi !== null ? Math.round(_ctx.pmi).toLocaleString() : ''), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", _hoisted_185, [
                    _hoisted_186,
                    _createElementVNode("td", _hoisted_187, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "monthlypayment",
                        value: _ctx.propertyTaxes,
                        "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.propertyTaxes) = $event)),
                        options: {
                                            precision: 0,
                                            prefix: '$ ',
                                            thousand: ',',
                                            acceptNegative: true,
                                            isInteger: false,
                                            decimal: '.',
                                        }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_188, [
                    _hoisted_189,
                    _createElementVNode("td", _hoisted_190, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "monthlypayment",
                        value: _ctx.propertyInsurance,
                        "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.propertyInsurance) = $event)),
                        options: {
                                            precision: 0,
                                            prefix: '$ ',
                                            thousand: ',',
                                            acceptNegative: true,
                                            isInteger: false,
                                            decimal: '.',
                                        }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_191, [
                    _hoisted_192,
                    _createElementVNode("td", _hoisted_193, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "monthlypayment",
                        value: _ctx.federalTaxes,
                        "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.federalTaxes) = $event)),
                        options: {
                                            precision: 0,
                                            prefix: '$ ',
                                            thousand: ',',
                                            acceptNegative: true,
                                            isInteger: false,
                                            decimal: '.',
                                        }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_194, [
                    _hoisted_195,
                    _createElementVNode("td", _hoisted_196, _toDisplayString(_ctx.financialInformation.propertyFloodInsurance?.value !== undefined
                                        ? '$' + _ctx.commaFormat(_ctx.financialInformation.propertyFloodInsurance?.value)
                                        : ''), 1)
                  ]),
                  _createElementVNode("tr", _hoisted_197, [
                    _hoisted_198,
                    _createElementVNode("td", _hoisted_199, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "association",
                        value: _ctx.financialInformation.association,
                        "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.financialInformation.association) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_200, [
                    _hoisted_201,
                    _createElementVNode("td", _hoisted_202, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "otherMontlhyPayment",
                        value: _ctx.financialInformation.otherMontlhyPayment,
                        "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.financialInformation.otherMontlhyPayment) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_203, [
            _createElementVNode("div", _hoisted_204, [
              _createElementVNode("div", _hoisted_205, [
                _createElementVNode("div", _hoisted_206, [
                  _hoisted_207,
                  _createVNode(_component_VueNumberFormat, {
                    id: "association",
                    value: _ctx.totalMonthly,
                    "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.totalMonthly) = $event)),
                    options: {
                                    precision: 0,
                                    prefix: '$ ',
                                    thousand: ',',
                                    acceptNegative: false,
                                    isInteger: false,
                                    decimal: '.',
                                },
                    class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3"
                  }, null, 8, ["value", "options"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_208, [
            _hoisted_209,
            _createElementVNode("div", _hoisted_210, [
              _createElementVNode("table", _hoisted_211, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", _hoisted_212, [
                    _hoisted_213,
                    _createElementVNode("td", _hoisted_214, _toDisplayString(_ctx.financialInformation.propertyClosingCostBuy?.text !== undefined
                                        ? '$' + _ctx.commaFormat(_ctx.financialInformation.propertyClosingCostBuy?.text)
                                        : ''), 1)
                  ]),
                  _createElementVNode("tr", _hoisted_215, [
                    _hoisted_216,
                    _createElementVNode("td", _hoisted_217, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "propertyBrokerPayment",
                        value: _ctx.financialInformation.propertyBrokerPayment,
                        "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.financialInformation.propertyBrokerPayment) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_218, [
            _hoisted_219,
            _createElementVNode("div", _hoisted_220, [
              _createElementVNode("div", _hoisted_221, [
                _createElementVNode("div", _hoisted_222, [
                  _hoisted_223,
                  _createVNode(_component_VueNumberFormat, {
                    id: "propertyIncomeMonthlyRent",
                    class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5",
                    value: _ctx.financialInformation.propertyRentDay,
                    "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.financialInformation.propertyRentDay) = $event)),
                    options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                  }, null, 8, ["value", "options"])
                ]),
                _createElementVNode("div", _hoisted_224, [
                  _hoisted_225,
                  _createElementVNode("input", {
                    name: "",
                    id: "",
                    type: "text",
                    disabled: "",
                    value: _ctx.financialInformation.propertyEstimateCapitalGainPlusvalia ? (_ctx.financialInformation.propertyEstimateCapitalGainPlusvalia * 100) : '',
                    class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                  }, null, 8, _hoisted_226)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_227, [
            _createElementVNode("div", _hoisted_228, [
              _createElementVNode("div", _hoisted_229, [
                _createElementVNode("div", _hoisted_230, [
                  _hoisted_231,
                  _createVNode(_component_VueNumberFormat, {
                    id: "totalInversment",
                    value: _ctx.totalInversment,
                    "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.totalInversment) = $event)),
                    disabled: "",
                    class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3",
                    options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: false, decimal: '.' }
                  }, null, 8, ["value", "options"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_232, [
              _createElementVNode("div", _hoisted_233, [
                _createElementVNode("div", _hoisted_234, [
                  _hoisted_235,
                  _createVNode(_component_VueNumberFormat, {
                    id: "netProfitPercent",
                    value: _ctx.netProfitPercent,
                    "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.netProfitPercent) = $event)),
                    disabled: "",
                    class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3",
                    options: { precision: 0, suffix: '% ', prefix: '', thousand: ',', acceptNegative: false, isInteger: false, decimal: '.' }
                  }, null, 8, ["value", "options"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_236, [
            _createElementVNode("button", {
              onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.submitScenario($event))),
              disabled: !_ctx.scenarioValid,
              class: "tw-bg-[#78c18a] disabled:tw-bg-[#ccc] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl"
            }, "SAVE & REGISTER", 8, _hoisted_237)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_238, [
      _createElementVNode("div", _hoisted_239, [
        _createElementVNode("div", _hoisted_240, [
          _hoisted_241,
          _createElementVNode("div", _hoisted_242, [
            _createElementVNode("div", _hoisted_243, [
              _createElementVNode("div", _hoisted_244, [
                _createElementVNode("button", {
                  onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.printScenario())),
                  class: "block"
                }, [
                  _hoisted_245,
                  _createTextVNode("PRINT")
                ])
              ]),
              _createElementVNode("div", _hoisted_246, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.generateMail()))
                }, [
                  _hoisted_247,
                  _createTextVNode("SEND")
                ]),
                _createVNode(_component_vue3_html2pdf, {
                  "show-layout": false,
                  "float-layout": true,
                  "enable-download": false,
                  "preview-modal": false,
                  "pdf-quality": 2,
                  "pdf-format": "a4",
                  "pdf-content-width": "800px",
                  "manual-pagination": true,
                  onBeforeDownload: _cache[33] || (_cache[33] = ($event: any) => (_ctx.beforeFileGenerated($event))),
                  ref: "html2Pdf"
                }, {
                  default: _withCtx(() => [
                    _hoisted_248
                  ]),
                  _: 1
                }, 512)
              ])
            ]),
            _createElementVNode("div", _hoisted_249, [
              _hoisted_250,
              _createElementVNode("div", _hoisted_251, [
                (_ctx.scenario.scenarioData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_252, [
                      _createElementVNode("div", _hoisted_253, [
                        _createElementVNode("table", _hoisted_254, [
                          _hoisted_255,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_256, [
                              _hoisted_257,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedProperty.name), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_258, [
                              _hoisted_259,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.filters.score), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_260, [
                              _hoisted_261,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.filters.program_name), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_262, [
                              _hoisted_263,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedYears.name), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_264, [
                              _hoisted_265,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedUser.username), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_266, [
                              _hoisted_267,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedUser.phonenumber), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_268, [
                              _hoisted_269,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedProgram.name), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_270, [
                              _hoisted_271,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedUser.interes_rate), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_272, [
                              _hoisted_273,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedUser.minimum_down_paymentlower), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_274, [
                              _hoisted_275,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedUser.minimum_down_paymenthigher), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_276, [
                              _hoisted_277,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedUser.average_mip_pmi), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_278, [
                              _hoisted_279,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedUser.backend_ratio), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_280, [
                              _hoisted_281,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedUser.maximum_loan), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("table", _hoisted_282, [
                          _hoisted_283,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_284, [
                              _hoisted_285,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_name), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_286, [
                              _hoisted_287,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_phonenumber), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_288, [
                              _hoisted_289,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_email), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("table", _hoisted_290, [
                          _hoisted_291,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_292, [
                              _hoisted_293,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyType.name), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_294, [
                              _hoisted_295,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyAddresses), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("table", _hoisted_296, [
                          _hoisted_297,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_298, [
                              _hoisted_299,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyPrice), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_300, [
                              _hoisted_301,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyDownPayment), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_302, [
                              _hoisted_303,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyEstimateLoan), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_304, [
                              _hoisted_305,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyInterestRate) + "% ", 1)
                            ]),
                            _createElementVNode("tr", _hoisted_306, [
                              _hoisted_307,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedYears.name), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_308, [
                              _hoisted_309,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedProgram.name), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_310, [
                              _hoisted_311,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyPmiMip), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_312, [
                              _hoisted_313,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyMonthlyPayment), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("table", _hoisted_314, [
                          _hoisted_315,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_316, [
                              _hoisted_317,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyClosingCostBuy?.text), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_318, [
                              _hoisted_319,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyBrokerPayment), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("table", _hoisted_320, [
                          _hoisted_321,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_322, [
                              _hoisted_323,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyAnnualNetProfit), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_324, [
                              _hoisted_325,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyAverageNetProfitYears), 1)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _hoisted_326
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_327, [
      _createElementVNode("div", _hoisted_328, [
        _createElementVNode("div", _hoisted_329, [
          _hoisted_330,
          _createElementVNode("div", _hoisted_331, [
            _createElementVNode("div", _hoisted_332, [
              _hoisted_333,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.scenarioMail.email) = $event)),
                class: "tw-w-full tw-h-[32px]",
                style: {"padding-left":"10px"}
              }, null, 512), [
                [_vModelText, _ctx.scenarioMail.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_334, [
              _hoisted_335,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.scenarioMail.subject) = $event)),
                class: "tw-w-full tw-h-[32px]",
                style: {"padding-left":"10px"}
              }, null, 512), [
                [_vModelText, _ctx.scenarioMail.subject]
              ])
            ]),
            _createElementVNode("div", _hoisted_336, [
              _withDirectives(_createElementVNode("textarea", {
                name: "",
                id: "",
                cols: "53",
                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.scenarioMail.message) = $event)),
                rows: "9"
              }, null, 512), [
                [_vModelText, _ctx.scenarioMail.message]
              ])
            ])
          ]),
          _hoisted_337,
          _createElementVNode("div", _hoisted_338, [
            _createElementVNode("div", _hoisted_339, [
              (_ctx.scenarioMail.file)
                ? (_openBlock(), _createElementBlock("button", _hoisted_340, [
                    _hoisted_341,
                    _createTextVNode(" " + _toDisplayString(_ctx.scenarioMail.file.name), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_342, [
              _createElementVNode("button", {
                "data-bs-dismiss": "modal",
                class: "tw-bg-[#78c18a] disabled:tw-bg-[#cfcfcf] disabled:tw-text-white tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl",
                disabled: _ctx.v$.scenarioMail.$invalid,
                onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.sendScenarioMail && _ctx.sendScenarioMail(...args)))
              }, "SEND MESSAGE", 8, _hoisted_343)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}